<template>
  <div class="post">
    <div v-if="loading" class="loading">Loading...</div>

    <div v-if="error" class="error">{{ error }}</div>

    <div v-if="post" class="content">
      <h2>{{ post.title }}</h2>
      <p>{{ post.body }}</p>
      {{formData}}
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "3DPaymentSuccessfulFB",
  data() {
    return {
      post: null,
      error: null,
      formData: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    this.getPost(to.params.id, (err, post) => {
      next(vm => vm.setData(err, post))
    })
  },
  async beforeRouteUpdate(to) {
    this.post = null
    try {
      this.post = await this.getPost(to.params.id)
    } catch (error) {
      this.error = error.toString()
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    setData(error, post) {
      if (error) {
        this.error = error
      } else {
        this.post = post
      }
    },
    getPost(postId, callback) {

      axios.get("http://localhost:8080/paymentRequest")
          .then(response => {
            callback(null, response.data);
          })
          .catch(error => {
            callback(error, null);
          });
    },
    fetchData() {
      axios.get('http://localhost:8080/paymentRequest') // veya uygun API endpointini kullanın
          .then(response => {
            this.formData = response.data; // Sunucudan gelen veriyi formData değişkenine atar
          })
          .catch(error => {
            console.error('Veri alınamadı:', error);
          });
    }
  }
}
</script>

<style scoped>

</style>
